import { api } from "./client";

export async function login(email: string, password: string, turnstile_token?: string) {
  const res = await api.post("/auth/login", {
    email,
    password,
    turnstile_token,
  });

  const { access_token, role } = res.data;

  localStorage.setItem("access_token", access_token);
  localStorage.setItem("role", role);

  return role;
}

export async function register(data: {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  confirm_password: string;
  terms_accepted: boolean;
  turnstile_token: string;
}) {
  const res = await api.post("/auth/register", data);
  return res.data;
}

export async function verifyEmail(
  payloadOrEmail: { email: string; code?: string; otp?: string } | string,
  maybeCode?: string
) {
  let email: string;
  let code: string;

  if (typeof payloadOrEmail === "object") {
    email = payloadOrEmail.email;
    code = payloadOrEmail.code || payloadOrEmail.otp || "";
  } else {
    email = payloadOrEmail;
    code = maybeCode || "";
  }

  const res = await api.post("/auth/verify-email", {
    email,
    code,
    otp: code,
  });

  if (res.data?.access_token) {
    localStorage.setItem("access_token", res.data.access_token);
    if (res.data.role) {
      localStorage.setItem("role", res.data.role);
    }
  }

  return res.data;
}

export async function resendOtp(
  payloadOrEmail: { email: string; turnstile_token?: string } | string,
  maybeToken?: string
) {
  let email: string;
  let turnstile_token: string | undefined;

  if (typeof payloadOrEmail === "object") {
    email = payloadOrEmail.email;
    turnstile_token = payloadOrEmail.turnstile_token;
  } else {
    email = payloadOrEmail;
    turnstile_token = maybeToken;
  }

  const res = await api.post("/auth/resend-otp", {
    email,
    turnstile_token,
  });
  return res.data;
}

export async function forgotPassword(
  payloadOrEmail: { email: string; turnstile_token?: string } | string,
  maybeToken?: string
) {
  let email: string;
  let turnstile_token: string | undefined;

  if (typeof payloadOrEmail === "object") {
    email = payloadOrEmail.email;
    turnstile_token = payloadOrEmail.turnstile_token;
  } else {
    email = payloadOrEmail;
    turnstile_token = maybeToken;
  }

  const res = await api.post("/auth/forgot-password", {
    email,
    turnstile_token,
  });
  return res.data;
}

export async function resetPassword(data: {
  token: string;
  password: string;
  confirm_password: string;
}) {
  const res = await api.post("/auth/reset-password", data);
  return res.data;
}

export async function googleAuth(credential: string, turnstile_token?: string) {
  const res = await api.post("/auth/google", {
    credential,
    turnstile_token,
  });

  const { access_token, role, csrf_token } = res.data;
  if (access_token) {
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("role", role);
  }

  return { access_token, role, csrf_token };
}

export async function fetchMe() {
  const res = await api.get("/auth/me");
  return res.data;
}

export async function updateProfile(data: {
  first_name?: string;
  last_name?: string;
  organization?: string;
  job_title?: string;
}) {
  const res = await api.patch("/users/me", data);
  return res.data;
}

export async function changePassword(data: {
  current_password: string;
  new_password: string;
  confirm_password: string;
}) {
  const res = await api.post("/users/me/change-password", data);
  return res.data;
}

export async function upgradeUserPlan(plan: string) {
  const res = await api.post("/auth/upgrade-plan", { plan });
  return res.data;
}

export async function logoutUser() {
  try {
    await api.post("/auth/logout");
  } catch (err) {
    console.warn("Server logout notification failed or offline:", err);
  } finally {
    localStorage.removeItem("access_token");
    localStorage.removeItem("role");
  }
}